import React from "react";
import Footer from "../components/Footer";
import Service from "../components/Service";

function Services() {

    return (
        <React.Fragment>
            <Service />
            <Footer />
        </React.Fragment>
    )
}

export default Services